// Create the context

import React from "react";

interface CallRecordUpdateData {
  callId: string;
  transcriptionId: string;
  userId?: string;
}

export interface WebSocketContextType {
  isConnected: () => boolean;
  reconnect: () => void;
  sendCallRecordUpdate: (data: CallRecordUpdateData) => void;
  sendTranscriptionReady: (callId: string, transcriptionId: string) => void;
  waitUntilConnected: (timeoutMs?: number) => Promise<boolean>;
}

export const WebSocketContext = React.createContext<WebSocketContextType | undefined>(undefined);

// Export the hook to use the context
export const useWebSocketContext = () => {
  const context = React.useContext(WebSocketContext);
  if (!context) {
    throw new Error("useWebSocketContext must be used within a WebSocketProvider");
  }
  return context;
};
